import {
  BudgetTierType,
  type BudgetTierValue,
} from '../../../../core/types/InsightsInstanceSlotData'

export const BUDGET_STATUS_COLORS_MAP = {
  [BudgetTierType.LOW_BUDGET_TIER]: 'success.main',
  [BudgetTierType.MEDIUM_BUDGET_TIER]: 'warning.main',
  [BudgetTierType.OFF_TRACK_BUDGET_TIER]: 'error.main',
}

export const getColorByBudgetTier = (budgetTier: BudgetTierValue) =>
  BUDGET_STATUS_COLORS_MAP[budgetTier]
